module.exports = "/_next/static/images/MultichannelMessaging@2x-8d795688091a8be5a5c5e431d76ec1fb.webp";